import React from 'react';
import { ErrorState } from '../../../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { GainLossDetailsSkeleton } from '../GainLossDetailsSkeleton/GainLossDetailsSkeleton';

interface Props {
  title: string;
  onRetry?(): void;
}

export const GainLossDetailsError = ({ title, onRetry }: Props) => {
  return (
    <GainLossDetailsSkeleton title={title}>
      <Box p="56" bg="bg">
        <ErrorState onAction={onRetry} />
      </Box>
    </GainLossDetailsSkeleton>
  );
};
